import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { Phone } from "@mui/icons-material";
import ContactsAutocomplete from "../ContactsAutocomplete";

const ConferencePanel = ({ open, onClose, onStartConference, currentCallee }) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedParticipants, setSelectedParticipants] = useState([]);

  const handleAddParticipant = (event, contact) => {
    if (!contact || !contact.id) {
      return;
    }

    // Prevent duplicates
    const isDuplicate = selectedParticipants.some(
      (participant) => participant.id === contact.id
    );

    if (isDuplicate) {
      console.log("Participant already added:", contact.name);
      return;
    }

    // Add contact to participants list
    setSelectedParticipants([...selectedParticipants, contact]);

    // Clear search value
    setSearchValue("");

    console.log("Added participant:", contact);
  };
  
  const handleDigitsParticipant = (digits) => {
    handleAddParticipant(null, {
      id: `noncrm-${digits}`,
      name: "",
      number: digits
    });
  }

  const handleRemoveParticipant = (participantId) => {
    setSelectedParticipants(
      selectedParticipants.filter((p) => p.id !== participantId)
    );
    console.log("Removed participant:", participantId);
  };

  const handleStartConference = () => {
    if (selectedParticipants.length === 0) {
      return;
    }

    console.log("Starting conference with participants:", selectedParticipants);
    onStartConference(selectedParticipants);

    // Reset state
    setSelectedParticipants([]);
    setSearchValue("");
  };

  const handleCancel = () => {
    // Reset state on cancel
    setSelectedParticipants([]);
    setSearchValue("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Conferência</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", pt: 1 }}>
          {/* Contact Search */}
          <ContactsAutocomplete
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleEnterAction={handleDigitsParticipant}
            includeCRM={true}
            onContactSelect={handleAddParticipant}
          />

          {/* Participants Section */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5 }}>
              Participantes da Conferência ({selectedParticipants.length + 1})
            </Typography>

            <Box
              sx={{
                p: 1.5,
                bgcolor: "grey.50",
                borderRadius: 1,
                border: "1px solid",
                borderColor: "grey.200",
                maxHeight: "200px",
                overflowY: "auto",
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {/* Current Callee (cannot be removed) */}
              {currentCallee && (
                <Chip
                  icon={<Phone sx={{ fontSize: 16 }} />}
                  label={`${currentCallee} (Chamada Atual)`}
                  color="success"
                  sx={{
                    maxWidth: "100%",
                    fontWeight: "bold",
                    "& .MuiChip-label": {
                      display: "block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                  }}
                />
              )}

              {/* Selected Participants (can be removed) */}
              {selectedParticipants.length === 0 && (
                <Box sx={{ width: "100%", textAlign: "center", py: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhum participante adicionado
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Busque e selecione contatos acima
                  </Typography>
                </Box>
              )}

              {selectedParticipants.map((participant) => (
                <Chip
                  key={participant.id}
                  label={`${participant.name} (${participant.number})`}
                  onDelete={() => handleRemoveParticipant(participant.id)}
                  color="primary"
                  sx={{
                    maxWidth: "100%",
                    "& .MuiChip-label": {
                      display: "block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="contained" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button
          color="success"
          variant="contained"
          onClick={handleStartConference}
          disabled={selectedParticipants.length === 0}
        >
          Iniciar Conferência
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConferencePanel;
